// eslint-disable-next-line import/prefer-default-export
export const ERouteLevelsNumber = {
  BASE_LEVEL: 0,
  FIRST_LEVEL: 1,
  SECOND_LEVEL: 2,
  THIRD_LEVEL: 3,
  FOURTH_LEVEL: 4,
};
